import axios from 'axios'
import { Notification, MessageBox, Message, Loading } from 'element-ui'
import store from '@/store'
import config from '@/config/index'
import errorCode from '@/utils/errorCode'
import { tansParams, blobValidate } from "@/utils/ruoyi";
import { saveAs } from 'file-saver'
import Cookies from "js-cookie";
/* 通过url 获取信息 */
const urlParams = new URLSearchParams(window.location.search)
console.log('通过url 获取信息',window.location)
let userId, platformId, openId, appId, platformUrl, garbledText, isPurchase, hasFinanceAdmin;
// 使用sessionStorage存储参数
try {
  userId = urlParams.get('userId');
  platformId = urlParams.get('platformId');
  openId = urlParams.get('openId');
  appId = urlParams.get('appId');
  platformUrl = urlParams.get('platformUrl');
  garbledText = urlParams.get('garbledText');
  isPurchase = urlParams.get('isPurchase');
  hasFinanceAdmin = urlParams.get('hasFinanceAdmin');
  
  if (userId) sessionStorage.setItem('userId', userId);
  if (platformId) sessionStorage.setItem('platformId', platformId);
  if (openId) sessionStorage.setItem('openId', openId);
  if (appId) sessionStorage.setItem('appId', appId);
  if (platformUrl) sessionStorage.setItem('platformUrl', platformUrl);
  if (garbledText) sessionStorage.setItem('garbledText', garbledText);
  if (isPurchase !== null && isPurchase !== undefined) sessionStorage.setItem('isPurchase', isPurchase); // 是否企业购商品
  if (hasFinanceAdmin !== null && hasFinanceAdmin !== undefined) {
    const normalized = hasFinanceAdmin === '1' || hasFinanceAdmin === 'true' || hasFinanceAdmin === true || hasFinanceAdmin === 1 ? '1' : '0'
    sessionStorage.setItem('hasFinanceAdmin', normalized); // 是否财务管理员权限 
    console.log('是否财务管理员权限 hasFinanceAdmin', normalized)
  }

  console.log('参数已存储到sessionStorage');

  // 读取参数时也优先从sessionStorage获取
  const storedUserId = sessionStorage.getItem('userId');
  const storedPlatformId = sessionStorage.getItem('platformId');
  console.log(sessionStorage.getItem('userId'));

  // console.log('从sessionStorage读取:', { storedUserId, storedPlatformId });
} catch (error) {
  console.error('存储参数到sessionStorage出错:', error);
}

let downloadLoadingInstance;
// 是否显示重新登录
export let isRelogin = { show: false };

axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
// 创建axios实例
const service = axios.create({
  // axios中请求配置有baseURL选项，表示请求URL公共部分
  // baseURL: 'http://192.168.110.132:8033',
  // baseURL: process.env.VUE_APP_BASE_API,
  baseURL: config.apiRequestUrl,
  // 超时
  timeout: 120000
})

// request拦截器
service.interceptors.request.use(config => {
  // 是否需要设置 token
  const isToken = (config.headers || {}).isToken === false
  // 是否需要防止数据重复提交
  const isRepeatSubmit = (config.headers || {}).repeatSubmit === false
  // if (getToken() && !isToken) {
  //   config.headers['Authorization'] = 'Bearer ' + getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
  // }
  // get请求映射params参数 + '?' + tansParams(config.params)
  if (config.method === 'get' && config.params) {
    let url = config.url;
    // url = url.slice(0, -1);
    config.params = {
      platformId: sessionStorage.getItem('platformId'),
      userId: sessionStorage.getItem('userId') == 1 ? undefined : sessionStorage.getItem('userId'),
      ...config.params // 保留原有的params参数
    };
    config.url = url;
  }
  // POST/PUT 请求添加 platformId 和 agencyId
  if ((config.method === 'post' || config.method === 'put') && config.data) {
    // 如果 data 是对象，则添加参数
    if (typeof config.data === 'object' && config.data !== null) {
      config.data = {
        platformId: sessionStorage.getItem('platformId'),
        userId: sessionStorage.getItem('userId') == 1 ? undefined : sessionStorage.getItem('userId'),
        ...config.data // 保留原有的data参数
      };
    }
    // 如果 data 是字符串（JSON），则解析后添加参数
    else if (typeof config.data === 'string') {
      try {
        const dataObj = JSON.parse(config.data);
        const newData = {
          platformId: platformId,
          agencyId: soId,
          ...dataObj
        };
        config.data = JSON.stringify(newData);
      } catch (e) {
        console.warn('无法解析请求数据为JSON格式:', e);
      }
    }
  }



  if (!isRepeatSubmit && (config.method === 'post' || config.method === 'put')) {
    const requestObj = {
      url: config.url,
      data: typeof config.data === 'object' ? JSON.stringify(config.data) : config.data,
      time: new Date().getTime()
    }
    const requestSize = Object.keys(JSON.stringify(requestObj)).length; // 请求数据大小
    const limitSize = 5 * 1024 * 1024; // 限制存放数据5M
    if (requestSize >= limitSize) {
      console.warn(`[${config.url}]: ` + '请求数据大小超出允许的5M限制，无法进行防重复提交验证。')
      return config;
    }

  }
  return config
}, error => {
  console.log(error)
  Promise.reject(error)
})

// 响应拦截器
service.interceptors.response.use(res => {
  // 未设置状态码则默认成功状态
  const code = res.data.code || 200;
  // 获取错误信息
  const msg = errorCode[code] || res.data.msg || errorCode['default']
  // 二进制数据则直接返回
  if (res.request.responseType === 'blob' || res.request.responseType === 'arraybuffer') {
    return res.data
  }
  if (code === 401) {
    if (!isRelogin.show) {
      isRelogin.show = true;
      MessageBox.confirm('登录状态已过期，您可以继续留在该页面，或者重新登录', '系统提示', { confirmButtonText: '重新登录', cancelButtonText: '取消', type: 'warning' }).then(() => {
        isRelogin.show = false;
        store.dispatch('LogOut').then(() => {
          location.href = '/index';
        })
      }).catch(() => {
        isRelogin.show = false;
      });
    }
    return Promise.reject('无效的会话，或者会话已过期，请重新登录。')
  } else if (code === 500) {
    Message({ message: msg, type: 'error' })
    return Promise.reject(new Error(msg))
  } else if (code === 601) {
    Message({ message: msg, type: 'warning' })
    return Promise.reject('error')
  } else if (code !== 200) {
    Notification.error({ title: msg })
    return Promise.reject('error')
  } else {
    return res.data
  }
},
  error => {
    console.log('err' + error)
    let { message } = error;
    if (message == "Network Error") {
      message = "后端接口连接异常";
    } else if (message.includes("timeout")) {
      message = "系统接口请求超时";
    } else if (message.includes("Request failed with status code")) {
      message = "系统接口" + message.substr(message.length - 3) + "异常";
    }
    Message({ message: message, type: 'error', duration: 5 * 1000 })
    return Promise.reject(error)
  }
)

// 通用下载方法
export function downloadDevices (url, params, filename, config) {
  downloadLoadingInstance = Loading.service({ text: "正在下载数据，请稍候", spinner: "el-icon-loading", background: "rgba(0, 0, 0, 0.7)", })
  return service.post(url, params, {
    transformRequest: [(params) => { return tansParams(params) }],
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    responseType: 'blob',
    ...config
  }).then(async (data) => {
    const isBlob = blobValidate(data);
    if (isBlob) {
      const blob = new Blob([data])
      saveAs(blob, filename)
    } else {
      const resText = await data.text();
      const rspObj = JSON.parse(resText);
      const errMsg = errorCode[rspObj.code] || rspObj.msg || errorCode['default']
      Message.error(errMsg);
    }
    downloadLoadingInstance.close();
  }).catch((r) => {
    console.error(r)
    Message.error('下载文件出现错误，请联系管理员！')
    downloadLoadingInstance.close();
  })
}


// 通用下载方法
export function downloadDevicesUtf_8 (url, params, filename, config) {
  downloadLoadingInstance = Loading.service({ text: "正在下载数据，请稍候", spinner: "el-icon-loading", background: "rgba(0, 0, 0, 0.7)", })
  return service.post(url, params, {
    transformRequest: [(params) => { return JSON.stringify(params) }],
    headers: { 'Content-Type': 'application/json' },
    responseType: 'blob',
    ...config
  }).then(async (data) => {
    const isBlob = blobValidate(data);
    if (isBlob) {
      const blob = new Blob([data])
      saveAs(blob, filename)
    } else {
      const resText = await data.text();
      const rspObj = JSON.parse(resText);
      const errMsg = errorCode[rspObj.code] || rspObj.msg || errorCode['default']
      Message.error(errMsg);
    }
    downloadLoadingInstance.close();
  }).catch((r) => {
    console.error(r)
    Message.error('下载文件出现错误，请联系管理员！')
    downloadLoadingInstance.close();
  })
}
export default service
